import { Injectable } from '@angular/core';
import { ToastService } from '@msi/cobalt-prime';

@Injectable({
  providedIn: 'root',
})
export class CommonToastService {
  constructor(private toastService: ToastService) {}

  /**
   * Shows a success toast with standard configuration
   * @param {string} message - The translated message to display
   * @param {number} life - Toast lifetime in milliseconds
   */
  showSuccess(message: string, life: number = 5000): void {
    this.toastService.success({
      summary: message,
      life: life,
      closable: true,
      sticky: false,
    });
  }

  /**
   * Shows an error toast with standard configuration
   * @param {string} message - The translated message to display
   * @param {number} life - Toast lifetime in milliseconds
   */
  showError(message: string, life: number = 5000): void {
    this.toastService.error({
      summary: message,
      life: life,
      closable: true,
      sticky: false,
    });
  }

  /**
   * Shows a warning toast with standard configuration
   * @param {string} message - The translated message to display
   * @param {number} life - Toast lifetime in milliseconds
   */
  showWarning(message: string, life: number = 5000): void {
    this.toastService.warning({
      summary: message,
      life: life,
      closable: true,
      sticky: false,
    });
  }
}
